import AffiliateCampaignManagement from "./affiliate-campaign-management.page";

export default AffiliateCampaignManagement;
